module.exports = __webpack_public_path__ + "img/65b0618.png";